import LogoJS from '../../images/logo-technologies/logo-js.webp'
import LogoHTML from '../../images/logo-technologies/logo-html.webp'
import LogoCSS from '../../images/logo-technologies/logo-css.webp'

import LogoPHP from '../../images/logo-technologies/logo-php.webp'
import LogoJAVA from '../../images/logo-technologies/logo-java.webp'
import LogoSwift from '../../images/logo-technologies/logo-swift.webp'
import LogoKotlin from '../../images/logo-technologies/logo-kotlin.webp'

const TechnologyStack = () =>{
    return(
        <section className="development-technology">
            <div className="containerFull">
                <h3>Delivery stack.</h3>

                <div className="development-stack development-stack-front">
                    <h4>AI-assisted engineering</h4>
                    <p>AI helps us move faster, but engineers remain responsible for the decisions, testing, and production safety. We use AI to accelerate implementation, analysis, refactoring, and testing — while every change stays attached to a ticket, reviewed by humans, and validated before production.</p>
                    <div className="technology-logo-list">
                        <div className="tech-logo-item"> <img src={LogoJS} alt="WooCommerce" loading='lazy'/> </div>
                        <div className="tech-logo-item"> <img src={LogoHTML} alt="Stripe" loading='lazy'/> </div>
                        <div className="tech-logo-item"> <img src={LogoCSS} alt="Paypal" /> </div>
                    </div>
                </div>

                <div className="development-stack development-stack-back">
                    <h4>Controlled delivery</h4>
                    <p>Every change moves through tickets, code review, staging environments, QA steps, pull requests, deployment checks, and rollback-aware delivery. We support web apps, mobile apps, APIs, admin panels, databases, integrations, payment systems, and cloud environments.</p>
                    <div className="technology-logo-list">
                        <div className="tech-logo-item"> <img src={ LogoPHP } alt="WooCommerce" loading='lazy'/> </div>
                        <div className="tech-logo-item"> <img src={ LogoJAVA } alt="Stripe" loading='lazy'/> </div>
                        <div className="tech-logo-item"> <img src={ LogoSwift } alt="Paypal" loading='lazy'/> </div>
                        <div className="tech-logo-item"> <img src={ LogoKotlin } alt="Paypal" loading='lazy'/> </div>
                    </div>
                </div>

            </div>
        </section>
    )
}

export default TechnologyStack


